import script from "./QuizResult.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizResult.vue?vue&type=script&setup=true&lang=js"

import "./QuizResult.vue?vue&type=style&index=0&id=6e46441d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e46441d"]])

export default __exports__